import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const PlayAlt = forwardRef<SVGSVGElement | null, IconFilledProps>(function PlayAlt({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.125 10.4846C20.2917 11.1582 20.2917 12.8421 19.125 13.5157L7.125 20.4439C5.95833 21.1175 4.5 20.2755 4.5 18.9284L4.5 5.07195C4.5 3.7248 5.95833 2.88283 7.125 3.5564L19.125 10.4846ZM18.375 12.2167C18.5417 12.1204 18.5417 11.8799 18.375 11.7836L6.375 4.85544C6.20833 4.75922 6 4.8795 6 5.07195L6 18.9284C6 19.1208 6.20833 19.2411 6.375 19.1449L18.375 12.2167Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.125 10.4846C20.2917 11.1582 20.2917 12.8421 19.125 13.5157L7.125 20.4439C5.95833 21.1175 4.5 20.2755 4.5 18.9284L4.5 5.07195C4.5 3.7248 5.95833 2.88283 7.125 3.5564L19.125 10.4846Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'play-alt-icon-svg'} iconRender={iconRender} {...props} />;
});

export default PlayAlt;
